package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier


@Composable
internal fun PageSecondaryContent(
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<SecondaryPageContentKind>? = null,
    content: @Composable () -> Unit,
) {
    Box(
        modifier = SecondaryPageContentStyle.toModifier(variant).then(modifier),
    ) {
        content()
    }
}

sealed interface SecondaryPageContentKind : ComponentKind

val SecondaryPageContentStyle = CssStyle<SecondaryPageContentKind> {
    base {
        Modifier
            .minHeight(Dimens.spacingNone)
            .fillMaxWidth()
            .padding(leftRight = Dimens.pageSecondaryLevelIndent, topBottom = Dimens.pageSecondaryLevelWrapping)
            .overflow(Overflow.Auto)
    }
}
